import i18next, { i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LocizeBackend from 'i18next-locize-backend';
import LocizeEditor from 'locize-editor';
import LocizeLastUsed from 'locize-lastused';

import { ITenantConfig } from 'packages/kakapo-ui-services/services/common/ConfigService';

export default class I18nFactory {
	static create(config: ITenantConfig): i18n {
		i18next.use(initReactI18next);
		i18next.use(LocizeBackend);
		i18next.use(LocizeEditor);
		i18next.use(LocizeLastUsed);

		const savedLanguage = localStorage.getItem('language');
		i18next.init({
			lng: savedLanguage == null ? 'en' : savedLanguage,
			fallbackLng: 'en',
			ns: 'translation',
			defaultNS: 'translation',
			debug: false,
			interpolation: {
				escapeValue: false, // already escaped by react
			},
			backend: {
				referenceLng: 'en',
				projectId: config.LOCIZE_PROJECT_ID,
				apiKey: config.LOCIZE_API_KEY,
			},
			locizeLastUsed: {
				projectId: config.LOCIZE_PROJECT_ID,
				apiKey: config.LOCIZE_API_KEY,
				referenceLng: 'en',
				allowedHosts: ['localhost', 'staging.ontreams.com'],
			},
		});
		return i18next;
	}
}
